<template>
  <section class="section-two bg-light mt-3 mb-2">
    <div class="container-fluid">
      <div class="row m-3 justify-content-center">
        <div class="col-lg-9">

          <div class="row">
            <div class="col-8">
              <p class="h5">
                <b>Escolha os exames</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
            <p>Busque pelo nome do exame como está no <b>pedido médico</b></p>
          </div>

          <div class="mb-2">
            <input type="text" class="form-control form-control-lg" v-model="search"
                   placeholder="Buscar exame">
          </div>

          <div v-for="exam in paginatedItems">
            <ExamCard :exam="exam" @addExam="addExam"/>
          </div>
        </div>
        <div class="col-lg-3" v-if="examsCart?.length > 0">
          <ExamCart :exams="examsCart"
                    :showFooter="true"
                    @removeAll="removeAll"
                    @addToCart="addToCart"
                    @removeItem="removeItem"/>
        </div>
      </div>

      <nav class="d-flex justify-content-center">
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
              Anterior
            </a>
          </li>

          <li
            class="page-item"
            v-for="page in visiblePages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
              Próximo
            </a>
          </li>
        </ul>
      </nav>

    </div>

    <div class="fixed-bottom d-md-none mx-3 mb-3">
      <div class="d-flex w-100">
        <button data-bs-target="#ExamModalCartList" data-bs-toggle="modal"
                class="btn btn-primary me-2">
          <i class="fa fa-shopping-bag me-2"></i> {{ examsCart.length }} Exames
        </button>

        <button class="btn btn-primary flex-grow-1"
                v-if="examsCart?.length > 0"
                type="button" @click="addToCart">
          Busca laboratório <i class="fa fa-arrow-circle-right me-2"></i>
        </button>
      </div>
    </div>

    <div class="modal fade" id="ExamModalCartList" tabindex="-1" aria-labelledby="ExamModalCartList" aria-hidden="true">
      <div class="modal-dialog">

        <div class="modal-content rounded shadow border-0">
          <div class="modal-header border-bottom">
            <h5 class="modal-title">Exames adicionados</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" v-for="exam in examsCart">
              <div class="m-3">
                <h4 class="fw-bold">{{ exam.item_name }}</h4>
                <p>
                  <b>Código: </b> {{exam.exam_tuss_code}} <br>
                  <span class="text-truncate-2">{{ exam.item_description }}</span>
                </p>
                <hr>
                <a class="text-danger" href="#" @click.prevent="removeItem(exam)">Remover exame</a>
              </div>
            </div>
            <div class="text-center" v-if="examsCart.length <= 0">
              <p>Nenhum exame adicionado</p>
            </div>
          </div>
          <div class="modal-footer" v-if="examsCart.length > 0">
            <button class="btn btn-sm btn-outline-danger" @click="removeAll">
              Remover todos
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ExamCard from "@/views/toSchedule/exams/ExamCard.vue";
import ExamCart from "@/views/toSchedule/exams/ExamCart.vue";
import http from "@/helpers/http";
import Swal from "sweetalert2";

export default {
  name: "ScheduleExams",
  components: {
    ExamCart,
    ExamCard,
  },
  data() {
    return {
      search: '',
      exams: [],
      examsCart: [],

      currentPage: 1,
      perPage: 5,
      maxVisiblePages: 4
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.exams?.length ?? 0 / this.perPage);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.examsList?.slice(start, end);
    },
    visiblePages() {
      const pages = [];

      let start = Math.max(1, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      let end = start + this.maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, end - this.maxVisiblePages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
    examsList() {
      let exams = this.exams;
      if (this.search === '')
        return exams;

      return exams.filter(exam => {
        let strFilter = JSON.stringify(exam);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  mounted() {
    this.getExams();
    this.examsCart = [];
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    addToCart() {
      this.$store.commit('toSchedule/setExams', this.examsCart);
      this.$router.push('/exams/places');
    },
    addExam(exam) {
      const existingExam = this.examsCart.find(e => e.id_item === exam.id_item);
      if (existingExam) {
        existingExam.alreadyExists = true;

        return;
      }

      exam.alreadyExists = true;
      this.examsCart.push(exam)
    },
    removeItem(item) {
      item.alreadyExists = false;
      this.examsCart = this.examsCart.filter(exam => exam.id_item !== item.id_item);

      this.$store.commit('toSchedule/setExams', this.examsCart);
    },
    removeAll() {
      Swal.fire({
        text: 'Tem certeza que deseja remover todos os exames?',
        icon: "warning",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#780f5a",
        confirmButtonText: "Sim, remover",
        cancelButtonText: "Não, manter exames",
      }).then((result) => {
        if (result.isConfirmed) {
          this.examsCart = [];

          this.$store.commit('toSchedule/setExams', this.examsCart);
          this.getExams();
        }
      });
    },
    getExams() {
      http.get('/schedule/exams', {
        params: {
          exam_type: this.$store.state.toSchedule.attendanceType,
          id_city: this.$store.state.toSchedule.schedule.city?.id_city,
          id_place: this.$store.state.toSchedule.place?.id_place,
          id_paymeth: this.$store.state.toSchedule.schedule.paymentMethod.id_paymeth,
          id_insurance: this.$store.state.toSchedule.schedule.insurance?.id_insurance,
        }
      }).then((response) => {
        this.exams = Array.isArray(response.data) ? response.data : [];
      });
    }
  }
}
</script>

<style scoped>

</style>